export default __webpack_public_path__ + "static/media/marketplace.69e4cee7.png";